import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/clients/2dddb5af0e226b301eba330a745cb36f/web/invento/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/clients/2dddb5af0e226b301eba330a745cb36f/web/invento/src/components/ecommerce/category-page-view.tsx");
